<banner-app [Fixtop]="''" [retroSelected]="false" [infoDueno]="true" [showPromo]="true"></banner-app>

<section class="container" role="contentinfo">
  <div class="row" role="row">
    @if (planes) {
    <div
      class="col-12 col-sm-12 text-primary-emphasis fw-bolder text-center my-4 lh-1 sura-main-container__hero-title d-flex flex-column">
      <div class="row content-heading my-lg-5 py-2 my-2" role="row">
        <div class="order-1 content-image col-12 col-4 col-md-4 text-center text-md-end">
          <img src="./assets/img/PantallaFin_PagoAprobado.png" width="200" height="120" loading="lazy"
            alt="seguro de moto precio" />
        </div>
        <div
          class="order-2 col-12 col-md-8 text-start d-flex flex-column justify-content-center text-center text-md-start">
          <h1>Tu pago ha sido aprobado</h1>
          <p>Te enviaremos un correo con la confirmación y los detalles de tu seguro.</p>
          <p class="payment-status" nf>
            Pago aprobado · $ {{ planes.data.plan.price.full.amount && planes.data.plan.price.full.amount |
            customNumberFormat }}
          </p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6 order-2 order-md-1 order-lg-1">
          <!-- Uso básico -->
          <app-payment-accordion [title]="'Información de pago'"
            [description]="'Pago aprobado · $' + (planes.data.plan.price.full.amount | customNumberFormat)"
            [iconType]="'check'" [iconStatus]="'success'" [items]="paymentItems()" (openedChange)="onToggle($event)" />

          <app-payment-accordion [title]="'Resumen de tu seguro'" [description]="insuranceSummaryDescription()"
            [iconType]="'info'" [iconStatus]="'info'" (openedChange)="onToggle($event)">
            <div class="plan-resume">
              <h4 class="plan-resume__planName">{{ this.planes?.data?.plan?.selected || '' }}</h4>
              <p class="plan-resume__vehicle">
                {{ this.planes?.data?.asset?.brand }} {{ this.planes?.data?.asset?.cylinder }}CC - {{
                this.planes?.data?.asset?.model }}
              </p>
              <p class="plan-resume__property">{{ planes.data.asset.owner.fullname }}</p>
              <p class="plan-resume__address">
                {{ planes.data.asset.owner.document.type }} {{ planes.data.asset.owner.document.number }} ·
                {{ planes.data.plan.zonaCirculacion }}
              </p>
            </div>

            <div class="coverage-content">
              <h4 class="coverage-title">Coberturas Incluidas:</h4>
              @if (planes?.data?.plan?.coveragesGroup?.length) {
              <ul class="coverage-list" role="list">
                @for (cobertura of planes.data.plan.coveragesGroup; track cobertura; let i = $index) {
                <li class="coverage-item" [attr.data-index]="i">
                  {{ cobertura.name }}
                </li>
                }
              </ul>
              }
            </div>

            <div class="contract-date">
              <p>Tu póliza de seguro inicia el</p>
              <p class="date">{{ planes.data.plan.effectiveDate }}</p>
            </div>
          </app-payment-accordion>

          <div class="payment-actions">
            <button class="btn-finish-flow" id="btn-endflow-motos" data-seo="btn-endflow-motos" (click)="entendido()">
              Finalizar
              <img src="./assets/img/svg/flecha-derecha.svg" width="16" height="16" alt="Ícono de flecha derecha" />
            </button>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-6 order-1 order-md-2 order-lg-2 mb-4 mb-lg-0">
          <app-ap-promo-card />
        </div>
      </div>
    </div>
    }
  </div>
</section>

<app-footer-app class="footer-fixed" />